import Vue from 'vue'
import Router from 'vue-router'
import {comp_EXP} from '@/assets/api'
Vue.use(Router)
const routes=new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:"/year_list",
      component:  () => import('@/index'),
      children:[
        {
          path: '/account',
          name: 'account',
          component:  () => import('@/components/account'),
        },
        {
          path: '/message',
          name: 'message',
          component:  () => import('@/components/message'),
        },
        {
          path: '/setting',
          name: 'setting',
          component:  () => import('@/components/setting'),
        },
        {
          path: '/year_list',
          name: 'year_list',
          component: () => import('@/components/yearFee/year_list')
        },
        {
          path: '/year_pay',
          name: 'year_pay',
          component: () => import('@/components/yearFee/year_pay')
        },
        {
          path: '/import_case',
          name: 'import_case',
          component: () => import("@/components/yearFee/import_case")
        },
        {
          path: '/buy_year',
          name: 'buy_year',
          component: () => import("@/components/yearFee/buy_year")
        }
      ]
    },
    {
      path: '/login', 
      name: 'login',
      component:  () => import('@/login'),
    },
    
  ]
})
routes.beforeEach((to, from, next) => {
  let is_EXP=comp_EXP();   //登录是否过期
  if( to.name=='login') {
      is_EXP?routes.push('/'):next()
  }
  else if(is_EXP) next();
  else 
    routes.push('login')
  
    
})


export default routes


// WEBPACK FOOTER //
// ./src/router/index.js